import { render, staticRenderFns } from "./Gestao.vue?vue&type=template&id=d3b4e326&scoped=true"
import script from "./Gestao.vue?vue&type=script&lang=js"
export * from "./Gestao.vue?vue&type=script&lang=js"
import style0 from "./Gestao.vue?vue&type=style&index=0&id=d3b4e326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b4e326",
  null
  
)

export default component.exports